export default __webpack_public_path__ + "static/media/image-slider01.f334504b.jpg";